export const SCROLL_GAP = 0;
export const SCROLL_STEP = 600;
export const SCROLL_THRESHOLD = 0;
